import { ISettingsTabsCtrlScope } from '../../settings/directives/tbSettingsCoordinator';
import { FeatureFlags } from '../FeatureFlags';
import { Module } from '../Module';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { ServerService } from '../services/ServerService';

export interface ISiteSettingsTabsCtrlScope extends ISettingsTabsCtrlScope {
  showAuthenticationTab: () => boolean;
  showRemoteAgentsSection: boolean;
}

export class SiteSettingsTabsCtrl {

  public static $inject = [
    '$scope',
    'BrowserTitleService',
    'ServerService'
  ];

  constructor(
            $scope: ISiteSettingsTabsCtrlScope,
            BrowserTitleService: BrowserTitleService,
            server: ServerService
  ) {
    const multisite = server.isSessionMultiSite();
    BrowserTitleService.setTitleWithPlace({translatablePlaceName: multisite ? 'siteSettings' : 'settings'});
    $scope.hideNameAndId = !multisite;

    $scope.server = server;
    $scope.showAuthenticationTab = () => {
      return server.isSiteSamlEnabled();
    };

    $scope.showRemoteAgentsSection = server.isBridgeEnabled();
    $scope.extensionsSettingsTabEnabled = FeatureFlags.extensionsSettingsTabEnabled;
    $scope.showEncryptionStatus = true;
  }
}

Module.instance().controller('SiteSettingsTabsCtrl', SiteSettingsTabsCtrl);
